import { render } from "./StandardShippingAndAddress.vue?vue&type=template&id=0927f833"
import script from "./StandardShippingAndAddress.vue?vue&type=script&lang=js"
export * from "./StandardShippingAndAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__